
export default {
  inject: ['bundle'],
  data() {
    return {
      bundle: this.bundle,
    }
  },
}
